import React, { useContext, useEffect, useState } from "react";
import { PortalContext } from "../../context/Provider";
import HeaderbarHome from "../../components/Genericos/HeaderbarHome/HeaderbarHome";
import FooterBar from "../../components/Genericos/Footer/FooterBar";
import Sidebar from "../../components/Genericos/Sidebar/Sidebar";
import Modal from "../../components/Genericos/Modal/Modal";
import BurguerMobile from "../../components/Genericos/BurguerMobile/BurguerMobile";
import ToasterV2 from "../../../global/component/Genericos/Toaster/ToasterV2";
import "./VideoTutoriales.css";
import CardVideoTutoriales from "./CardVideoTutoriales/CardVideoTutoriales";
import { wsGetTraerVideos } from "../../context/Actions/CardVideoTutoriales/CardVideoTutoriales";
import Loading from "../../components/Genericos/Loading/Loading";
import BotonSubir from "../../assets/images/generico/BotonSubir";
import { GlobalContext } from "../../../global/context/Provider";
import FloatingScroll from "_+_Portal/components/Genericos/FloatingScroll/FloatingScroll";

const VideoTutoriales = () => {
  // Esto es la carcaza de la page
  const { modalState, cardVideoTutorialesState, cardVideoTutorialesDispatch } =
    useContext(PortalContext);

  const { toasterState } = useContext(GlobalContext);

  const [showBurguerMobile, setShowBurguerMobile] = useState(false);

  const onShowBurguerHandle = () => {
    setShowBurguerMobile(true);
  };

  const onCloseBurguerMobile = (type) => {
    if (type === "open") setShowBurguerMobile(true);
    else setShowBurguerMobile(false);
  };

  useEffect(() => {
    wsGetTraerVideos()(cardVideoTutorialesDispatch);
  }, []);

  return (
    <React.Fragment>
      {modalState.modal.show && <Modal />}
      {toasterState.toaster.show && <ToasterV2 />}
      {/* HEADER BAR DE PORTAL  */}
      <BurguerMobile
        onCloseBurguerMobile={onCloseBurguerMobile}
        showBurguerMobile={showBurguerMobile}
      />
      <HeaderbarHome onShowBurguerHandle={onShowBurguerHandle} />

      <div className="ptur-videoTutoriales">
        <Sidebar />
        {cardVideoTutorialesState.cardVideoTutoriales.loading ? (
          <Loading
            dataLoading={cardVideoTutorialesState.cardVideoTutoriales.loading}
            color="c-white"
            descripcion={"Cargando los videos ..."}
          />
        ) : cardVideoTutorialesState.cardVideoTutoriales.error ? (
          "Ha ocurrido un error"
        ) : cardVideoTutorialesState.cardVideoTutoriales.data ? (
          <div className="mismed-body-videoTutoriales">
            <div className="ptur-videoTutoriales-cards-container">
              {cardVideoTutorialesState.cardVideoTutoriales.data.map(
                (card, index) => {
                  return <CardVideoTutoriales key={index} card={card} />;
                }
              )}
            </div>

            {cardVideoTutorialesState.cardVideoTutoriales.loading ? (
              ""
            ) : (
              // <div className="ptur-misMedicos-botonSubir">
              //   <BotonSubir body={"mismed-body-videoTutoriales"} />
              // </div>
              <FloatingScroll body={"mismed-body-videoTutoriales"} />
            )}
          </div>
        ) : (
          ""
        )}
      </div>
    </React.Fragment>
  );
};
export default VideoTutoriales;
